(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gc-system', {
            parent: 'entity',
            url: '/gc-system',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.gcSystem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gc-system/gc-systems.html',
                    controller: 'GcSystemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gcSystem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gc-system-detail', {
            parent: 'gc-system',
            url: '/gc-system/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.gcSystem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gc-system/gc-system-detail.html',
                    controller: 'GcSystemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gcSystem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GcSystem', function($stateParams, GcSystem) {
                    return GcSystem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gc-system',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gc-system-detail.edit', {
            parent: 'gc-system-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gc-system/gc-system-dialog.html',
                    controller: 'GcSystemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GcSystem', function(GcSystem) {
                            return GcSystem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gc-system.new', {
            parent: 'gc-system',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gc-system/gc-system-dialog.html',
                    controller: 'GcSystemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                endpoint: null,
                                partnerId: null,
                                programId: null,
                                currencyCode: null,
                                awsAccessKey: null,
                                awsSecretKey: null,
                                region: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gc-system', null, { reload: 'gc-system' });
                }, function() {
                    $state.go('gc-system');
                });
            }]
        })
        .state('gc-system.edit', {
            parent: 'gc-system',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gc-system/gc-system-dialog.html',
                    controller: 'GcSystemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GcSystem', function(GcSystem) {
                            return GcSystem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gc-system', null, { reload: 'gc-system' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gc-system.delete', {
            parent: 'gc-system',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gc-system/gc-system-delete-dialog.html',
                    controller: 'GcSystemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GcSystem', function(GcSystem) {
                            return GcSystem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gc-system', null, { reload: 'gc-system' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
